<div class="report-container">
  <hyperkit-typography variant="h5">Overview</hyperkit-typography>
  <report-text-block 
    title="Executive Summary"
    [value]="huntContext.editor.executiveSummary()">
  </report-text-block>
  
  <report-text-block 
    title="Abstract"
    [value]="huntContext.editor.abstract()">
  </report-text-block>
  
  <report-text-block 
    title="Hypothesis"
    [value]="huntContext.editor.hypothesis()">
  </report-text-block>
</div>

